import { render, staticRenderFns } from "./ProductReportStatic.vue?vue&type=template&id=1ab3a322&scoped=true&"
import script from "./ProductReportStatic.vue?vue&type=script&lang=js&"
export * from "./ProductReportStatic.vue?vue&type=script&lang=js&"
import style0 from "./ProductReportStatic.vue?vue&type=style&index=0&id=1ab3a322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab3a322",
  null
  
)

export default component.exports